
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import { namespace } from "vuex-class";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
const service = namespace("service");
const staff = namespace("staff");
const setting = namespace("setting");
@Component({})
export default class SettlementPrint extends Vue {
  @staff.Action getStaffList;
  @service.Action getPrintStoreLogo;
  @setting.Action queryPrintFieldListByCategory;
  @Prop({ default: () => {}, type: Object })
  orderData: any;
  @Prop({ default: () => {}, type: Object })
  orderDataFake: any;
  @Prop({ default: "", type: String })
  receiveServicePhone: string;
  @Prop({ default: undefined })
  receiveFieldList: any;
  printLogo: string = "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png";
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  advisorList: any[] = [{}];
  fieldList: any = [];
  get availableFieldArr() {
    if (this.receiveFieldList) {
      return this.receiveFieldList.filter(item => item.status === 1).map(item => item.fieldCode);
    }
    return this.fieldList.filter(item => item.status === 1).map(item => item.fieldCode);
  }
  created() {
    console.log("[ $orderData.allOrderDetail ]", this.$orderData.allOrderDetail);
    this.getStaffList({
      // 获取所有员工
      pageNum: 1,
      pageSize: 999
    }).then(data => {
      this.advisorList = data.data.list;
    });
    this.getLogoImg();
    this.getTemplateField();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.printLogo = res.data.storeLogo;
    });
  }
  templateServicePhone: string = "";
  getTemplateField() {
    this.queryPrintFieldListByCategory({ category: "PRINT_PAYMENT_CREDENTIALS" }).then(data => {
      this.fieldList = this.$safeValue(data, "data.printFieldList", []);
      this.templateServicePhone = this.$safeValue(data, "data.templateServicePhone", "");
    });
  }
  returnStaffName(userCode) {
    let obj = userCode ? this.advisorList.find(item => item.userCode === userCode) : "";
    return obj ? obj.staffName : "";
  }
  get $orderData() {
    console.log("[ this.orderData ]", this.orderData);
    return this.orderData || this.orderDataFake;
  }
}
